import React from "react"
import { CaldaiaDto } from "../../generated"
import { CaldaieStore } from "../caldaieStore";

interface Props {
    id: number | undefined | null;
    template: (caldaia: CaldaiaDto) => JSX.Element | string | number;
}

export default ({ id, template }: Props) => {
    if (!id)
        return null;
    const item = CaldaieStore.use(id);
    if (item == null) return null;
    return <>{template(item)}</>;
}
